import type { LabelInValue } from 'models';
import { useTranslation } from 'react-i18next';
import { type ModalOptions, QrCodeModal } from 'ui';
import { getSafeFileName } from 'common/utils';
import { useInvitationTokenQuery } from '../../../queries';
import { useGenerateInvitationLink } from '../hooks';

type P = {
  onCancel: () => void;
  options: ModalOptions<ShareQrCodeModalOptions>;
};

type ShareQrCodeModalOptions = {
  community: LabelInValue;
};

const ShareQrCodeModal = ({ onCancel, options }: P) => {
  const { t } = useTranslation();
  const generateToken = useGenerateInvitationLink();
  const communityId = options.isOpened ? options.community.value : '';

  const {
    data: invitationToken,
    error,
    isLoading,
  } = useInvitationTokenQuery({
    communityId,
  });

  const fileName =
    options.isOpened && typeof options.community.label === 'string'
      ? `${getSafeFileName({ name: options.community.label })} ${t('Invitation QR Code')}`
      : 'Community Invitation QR Code';

  return (
    <QrCodeModal
      alerts={[
        {
          description:
            'You can display the QR code for someone nearby, share it through messaging apps, or download it to your device for later use',
        },
        {
          description:
            'By scanning the QR code, the recipient can accept the invitation and join the platform seamlessly. The process is quick and straightforward.',
        },
      ]}
      error={error}
      fileName={fileName}
      isLoading={isLoading}
      isOpened={options.isOpened}
      onCancel={onCancel}
      qrCodeValue={generateToken({ communityId, token: invitationToken?.token ?? '' })}
      title="Invite via QR code"
    />
  );
};

export default ShareQrCodeModal;
